import React, { useState, useEffect } from 'react';
import { Bus, Zap, Wifi, Plug, Users } from 'lucide-react';
import { fleetAPI } from '../services/api';
import './Fleet.css';

const Fleet = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFleet();
  }, []);

  const loadFleet = async () => {
    setLoading(true);
    try {
      const data = await fleetAPI.getAllVehicles();
      setVehicles(data);
    } catch (error) {
      console.error('Error loading fleet:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFeatureIcon = (feature) => {
    if (feature.toLowerCase().includes('wi-fi') || feature.toLowerCase().includes('wifi')) return <Wifi size={18} />;
    if (feature.toLowerCase().includes('usb') || feature.toLowerCase().includes('charging')) return <Plug size={18} />;
    if (feature.toLowerCase().includes('electric')) return <Zap size={18} />;
    return null;
  };

  return (
    <div className="fleet-page">
      <section className="fleet-hero">
        <div className="container">
          <h1 className="page-title">Flota Noastră</h1>
          <p className="page-subtitle">
            Vehicule moderne, confortabile și ecologice pentru călătorii plăcute
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loading-state">Se încarcă vehiculele...</div>
          ) : (
            <div className="fleet-grid">
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} className="vehicle-card card">
                  <div className="vehicle-image">
                    <Bus size={64} />
                  </div>
                  <div className="vehicle-info">
                    <h3 className="vehicle-name">{vehicle.name}</h3>
                    <span className="vehicle-type">{vehicle.type}</span>

                    <div className="vehicle-stats">
                      <div className="vehicle-stat">
                        <Users size={20} />
                        <span>{vehicle.capacity} locuri</span>
                      </div>
                      <div className="vehicle-stat">
                        <Zap size={20} />
                        <span>{vehicle.fuelType}</span>
                      </div>
                      <div className="vehicle-stat">
                        <span>An: {vehicle.year}</span>
                      </div>
                    </div>

                    <div className="vehicle-features">
                      <h4>Facilități:</h4>
                      <ul>
                        {vehicle.features.map((feature, index) => (
                          <li key={index}>
                            {getFeatureIcon(feature)}
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Fleet;
